export function formatAsDollar(number:number) {
    if (typeof number !== 'number') {
      return 'Invalid input';
    }
  
    // Преобразуем число в строку и заменяем точку на запятую
    const formattedNumber = '$' + number.toFixed(2).replace('.', ',');
    return formattedNumber;
}